import { ApprovalStepStatus } from '../../types';
import { useMemo } from 'react';
import ApprovalEditPanelReviewTable from './ApprovalEditPanelReviewTable';
import ApprovalEditFullyApprovedAlert from './ApprovalEditFullyApprovedAlert';
import { countChangeBetweenLists } from '../../utils/countChangesBetweenLists';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalEditPanelReview = props => {
  const {
    approvedApproverIds,
    approversAll,
    assetName,
    selectedApproverIdsMutable
  } = props;
  const willBeApprovedAfterEdit = useMemo(() => countChangeBetweenLists(approvedApproverIds, selectedApproverIdsMutable) === 0, [approvedApproverIds, selectedApproverIdsMutable]);
  const approversWithStepStatuses = useMemo(() => {
    const approversWithStatus = approversAll.filter(approver => selectedApproverIdsMutable.includes(approver.ownerId)).map(approver => approvedApproverIds.includes(approver.ownerId) ? [approver, ApprovalStepStatus.APPROVED] : [approver, ApprovalStepStatus.APPROVAL_PENDING]);
    return approversWithStatus;
  }, [approversAll, approvedApproverIds, selectedApproverIdsMutable]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [willBeApprovedAfterEdit && /*#__PURE__*/_jsx(ApprovalEditFullyApprovedAlert, {}), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-3",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalEditPanel.stepTwoDescription",
        options: {
          assetName,
          count: approversWithStepStatuses.length
        }
      })
    }), /*#__PURE__*/_jsx(ApprovalEditPanelReviewTable, {
      approversWithStepStatuses: approversWithStepStatuses
    })]
  });
};
export default ApprovalEditPanelReview;